export const EDITOR_CONTENT_LENGTH_DEFAULTS = {
  MIN: 0,
  MAX: 5000,
}
